import { useTranslation } from 'react-i18next';

import { Button, Drawer } from '@/components';
import { Project } from '@/features/projects/types';
import { PermitsFormNew } from './permits-form-new';

export type PermitsDrawerProps = {
  readonly formId: string
  readonly project: Project;
  readonly onSubmit: (item: any, description?: string) => void;
  readonly onClose: () => void;
  readonly country: string;
  readonly isOpen: boolean;
  readonly deletePermitNew: (id: any) => void;
};

export function PermitNewDrawer({ formId, project, onSubmit, onClose, country, isOpen, deletePermitNew }: PermitsDrawerProps) {
  const { t } = useTranslation(['projects']);

  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Permitting (PLAs)')} open={isOpen} onClose={onClose} footer={footer}>
      <PermitsFormNew
        id={formId}
        project={project}
        onSubmit={(data: any) => {
          onSubmit(data, t('Permits section has been updated'));
        }}
        country={country}
        deletePermit={deletePermitNew}
      />
    </Drawer>
  );
}
